/* FAIR — Bundle BOGO Logic v1.3. Step 1: pick 2 necklaces (auto-advance + slide). Step 2: pick 2 free bracelets. Applies code at checkout. */
(function () {
  'use strict';

  const SELECTED_CLASS = 'is-selected';
  const LOCKED_CLASS = 'is-locked';
  const HAS_VARIANT_CLASS = 'has-variant';

  const SIZE_GUIDE_CONTENT = {
    necklace: {
      title: 'Necklace size guide',
      sub: 'Find the length that sits where you want it.',
      html: ''
        + '<img class="fbb-modal__image" src="https://cdn.shopify.com/s/files/1/0703/8759/7427/files/chain-sizes-frontal.webp?v=1780025320" alt="Chain lengths" loading="lazy">'
        + '<img class="fbb-modal__image" src="https://cdn.shopify.com/s/files/1/0703/8759/7427/files/chain-sizes-comparison.webp?v=1780025304" alt="Chain comparison" loading="lazy">'
        + '<div class="fbb-modal__stats">'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">Model height</div><div class="fbb-modal__stat-value">5\'11&quot;</div></div>'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">Most picked</div><div class="fbb-modal__stat-value"><strong>20&quot;</strong></div></div>'
        + '</div>'
        + '<p>Use the photos to decide how you want your chain to sit — high on the collarbone, on the sternum, or lower.</p>'
        + '<div class="fbb-modal__tip"><p><strong>Not sure?</strong> Go with 20\". Sits cleanly on a crew neck tee and layers well.</p></div>'
    },
    bracelet: {
      title: 'Bracelet size guide',
      sub: 'Measure once, get it right.',
      html: ''
        + '<p>Bracelet sizes are listed as <strong>circumference in inches</strong>.</p>'
        + '<p><strong>To measure your wrist:</strong> wrap a piece of string or paper around your wrist, mark or cut where it joins, then measure against a ruler in inches. In between sizes? Always opt for the larger size.</p>'
        + '<div class="fbb-modal__stats">'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">In between sizes?</div><div class="fbb-modal__stat-value"><strong>Size up</strong></div></div>'
        +   '<div class="fbb-modal__stat"><div class="fbb-modal__stat-label">One size fits all</div><div class="fbb-modal__stat-value">7.5&quot; – 8.5&quot;</div></div>'
        + '</div>'
        + '<p><strong>Beaded and leather bracelets:</strong> some are marked &quot;one size fits all&quot; — designed to fit all wrists from 7.5&quot; to 8.5&quot;.</p>'
        + '<div class="fbb-modal__tip"><p><strong>Rule of thumb:</strong> between two sizes, pick the larger one.</p></div>'
    }
  };

  class BogoBuilder {
    constructor(root) {
      this.root = root;
      this.buyQty = parseInt(root.dataset.buyQty, 10) || 2;
      this.getQty = parseInt(root.dataset.getQty, 10) || 2;
      this.code = root.dataset.discountCode || '';
      this.buyColl = (root.dataset.buyCollection || '').toLowerCase();
      this.getColl = (root.dataset.getCollection || '').toLowerCase();

      this.step = 1;
      this.buySel = [];
      this.getSel = [];
      this.pendingVariants = {};
      this._animating = false;

      this.grid = root.querySelector('[data-fbogo-grid]');
      this.progress = root.querySelector('[data-fbogo-progress]');
      this.toast = root.querySelector('[data-fbogo-toast]');
      this.countEl = root.querySelector('[data-fbogo-count]');
      this.barFillEl = root.querySelector('[data-fbogo-bar-fill]');
      this.amountEl = root.querySelector('[data-fbogo-amount]');
      this.savedEl = root.querySelector('[data-fbogo-saved]');
      this.ctaEl = root.querySelector('[data-fbogo-cta]');
      this.backEl = root.querySelector('[data-fbogo-back]');
      this.stepInds = root.querySelectorAll('[data-fbogo-step-ind]');

      this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

      this.init();
    }

    init() {
      this.buildModal();
      this.bindEvents();
      this.initCarousels();
      this.applyStepFilter();
      this.render();
      const self = this;
      requestAnimationFrame(function () { if (self.progress) self.progress.classList.add('is-visible'); });
    }

    cardType(card) {
      const cols = (card.dataset.collections || '').toLowerCase();
      if (cols.indexOf(this.buyColl) >= 0) return 'buy';
      if (cols.indexOf(this.getColl) >= 0) return 'get';
      return 'buy';
    }

    curSel() { return this.step === 1 ? this.buySel : this.getSel; }
    curLimit() { return this.step === 1 ? this.buyQty : this.getQty; }
    curType() { return this.step === 1 ? 'buy' : 'get'; }
    selFor(type) { return type === 'buy' ? this.buySel : this.getSel; }
    limitFor(type) { return type === 'buy' ? this.buyQty : this.getQty; }

    qtyOf(sel, productId) {
      let n = 0;
      for (let i = 0; i < sel.length; i++) if (sel[i].productId === productId) n++;
      return n;
    }

    /* ===== Carousel dots ===== */
    initCarousels() {
      if (!this.grid) return;
      this.grid.querySelectorAll('[data-fbb-slides]').forEach(function (slides) {
        const parent = slides.parentElement;
        const dotsEl = parent ? parent.querySelector('[data-fbb-dots]') : null;
        if (!dotsEl) return;
        const dots = dotsEl.querySelectorAll('.fbb-card__dot');
        if (dots.length < 2) return;
        let ticking = false;
        slides.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            const w = slides.clientWidth || 1;
            const idx = Math.round(slides.scrollLeft / w);
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
            ticking = false;
          });
        }, { passive: true });
      });
    }

    /* ===== Size guide modal ===== */
    buildModal() {
      const modal = document.createElement('div');
      modal.className = 'fbb-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = ''
        + '<div class="fbb-modal__overlay" data-fbb-modal-close></div>'
        + '<div class="fbb-modal__dialog" role="document">'
        +   '<button type="button" class="fbb-modal__close" data-fbb-modal-close aria-label="Close">✕</button>'
        +   '<div class="fbb-modal__header"><h2 class="fbb-modal__title" data-fbb-modal-title></h2><p class="fbb-modal__sub" data-fbb-modal-sub></p></div>'
        +   '<div class="fbb-modal__body" data-fbb-modal-body></div>'
        + '</div>';
      document.body.appendChild(modal);
      this.modalEl = modal;
      this.modalDialogEl = modal.querySelector('.fbb-modal__dialog');
      this.modalTitleEl = modal.querySelector('[data-fbb-modal-title]');
      this.modalSubEl = modal.querySelector('[data-fbb-modal-sub]');
      this.modalBodyEl = modal.querySelector('[data-fbb-modal-body]');
    }

    openSizeGuide(type) {
      const c = SIZE_GUIDE_CONTENT[type] || SIZE_GUIDE_CONTENT.bracelet;
      this.modalTitleEl.textContent = c.title;
      this.modalSubEl.textContent = c.sub;
      this.modalBodyEl.innerHTML = c.html;
      this.modalEl.classList.add('is-open');
      this.modalEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (this.modalDialogEl) this.modalDialogEl.scrollTop = 0;
    }
    closeSizeGuide() {
      this.modalEl.classList.remove('is-open');
      this.modalEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    /* ===== Events ===== */
    bindEvents() {
      const self = this;
      if (this.grid) {
        this.grid.addEventListener('click', function (e) {
          const guideBtn = e.target.closest('[data-fbb-size-guide]');
          if (guideBtn) { e.preventDefault(); e.stopPropagation(); self.openSizeGuide(guideBtn.dataset.guideType || 'bracelet'); return; }
          const pill = e.target.closest('[data-fbb-variant]');
          if (pill && !pill.disabled) { e.preventDefault(); self.pickVariant(pill); return; }
          const minus = e.target.closest('[data-fbb-qty-minus]');
          if (minus) { e.preventDefault(); const card = minus.closest('[data-fbb-card]'); if (card) self.removeUnit(card); return; }
          const plus = e.target.closest('[data-fbb-qty-plus]');
          if (plus && !plus.disabled) { e.preventDefault(); const card = plus.closest('[data-fbb-card]'); if (card) self.addUnit(card); return; }
          const action = e.target.closest('[data-fbb-action]');
          if (action && !action.disabled) { e.preventDefault(); const card = action.closest('[data-fbb-card]'); if (card) self.addUnit(card); }
        });
      }
      if (this.modalEl) {
        this.modalEl.addEventListener('click', function (e) { if (e.target.closest('[data-fbb-modal-close]')) self.closeSizeGuide(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modalEl && self.modalEl.classList.contains('is-open')) self.closeSizeGuide();
      });
      if (this.ctaEl) {
        this.ctaEl.addEventListener('click', function () {
          if (self.step === 1) {
            if (self.buySel.length === self.buyQty) self.goStep(2);
          } else {
            if (self.getSel.length === self.getQty) self.addAllToCart();
          }
        });
      }
      if (this.backEl) {
        this.backEl.addEventListener('click', function () { self.goStep(1); });
      }
    }

    pickVariant(pill) {
      const card = pill.closest('[data-fbb-card]');
      if (!card) return;
      const productId = card.dataset.productId;
      const variantId = pill.dataset.variantId;
      const variantPrice = parseInt(pill.dataset.variantPrice, 10);
      this.pendingVariants[productId] = { variantId: variantId, price: variantPrice };
      card.querySelectorAll('[data-fbb-variant]').forEach(function (p) {
        const active = p === pill;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      card.classList.add(HAS_VARIANT_CLASS);
      const action = card.querySelector('[data-fbb-action]');
      if (action) action.disabled = false;
      const priceEl = card.querySelector('[data-fbb-price]');
      if (priceEl && this.cardType(card) === 'buy') priceEl.textContent = this.formatMoney(variantPrice);
      const t = this.cardType(card);
      const sel = this.selFor(t);
      let changed = false;
      sel.forEach(function (i) { if (i.productId === productId) { i.variantId = variantId; i.price = variantPrice; changed = true; } });
      if (changed) this.render();
    }

    addUnit(card) {
      const t = this.cardType(card);
      if (t !== this.curType()) return;
      const sel = this.curSel();
      const limit = this.curLimit();
      if (sel.length >= limit) { this.showToast('Max ' + limit + ' — remove one to swap.', 'warning'); return; }
      const productId = card.dataset.productId;
      const needsPick = card.dataset.needsPick === 'true';
      let variantId, price;
      if (needsPick) {
        const pending = this.pendingVariants[productId];
        if (pending) { variantId = pending.variantId; price = pending.price; }
        else {
          const existing = sel.find(function (i) { return i.productId === productId; });
          if (existing) { variantId = existing.variantId; price = existing.price; }
          else { this.showToast('Pick a size first.', 'warning'); return; }
        }
      } else {
        variantId = card.dataset.defaultVariantId;
        price = parseInt(card.dataset.defaultPrice, 10);
      }
      sel.push({ variantId: variantId, productId: productId, price: price, image: card.dataset.image, title: card.dataset.title });
      this.render();
      this.maybeAutoAdvance();
    }

    maybeAutoAdvance() {
      if (this.step !== 1 || this.buySel.length !== this.buyQty) return;
      const self = this;
      clearTimeout(this._advance);
      this._advance = setTimeout(function () {
        if (self.step === 1 && self.buySel.length === self.buyQty) self.goStep(2);
      }, 200);
    }

    removeUnit(card) {
      const t = this.cardType(card);
      const sel = this.selFor(t);
      const productId = card.dataset.productId;
      for (let i = sel.length - 1; i >= 0; i--) { if (sel[i].productId === productId) { sel.splice(i, 1); break; } }
      if (t === 'buy') clearTimeout(this._advance);
      this.render();
    }

    goStep(n) {
      if (this._animating || n === this.step) return;
      clearTimeout(this._advance);
      const self = this;
      const grid = this.grid;
      if (!grid) { this.step = n; this.applyStepFilter(); this.render(); return; }
      const dir = n > this.step ? 1 : -1;
      this._animating = true;
      grid.style.willChange = 'opacity, transform';
      grid.style.transition = 'opacity 0.15s ease, transform 0.15s ease';
      grid.style.opacity = '0';
      grid.style.transform = 'translateX(' + (dir * -28) + 'px)';
      setTimeout(function () {
        self.step = n;
        self.applyStepFilter();
        self.render();
        grid.style.transition = 'none';
        grid.style.transform = 'translateX(' + (dir * 28) + 'px)';
        void grid.offsetWidth;
        grid.style.transition = 'opacity 0.22s ease, transform 0.22s cubic-bezier(0.22, 1, 0.36, 1)';
        grid.style.opacity = '1';
        grid.style.transform = 'translateX(0)';
        setTimeout(function () {
          self._animating = false;
          grid.style.transition = '';
          grid.style.transform = '';
          grid.style.willChange = '';
        }, 240);
      }, 150);
    }

    applyStepFilter() {
      if (!this.grid) return;
      const self = this;
      const cur = this.curType();
      this.root.classList.toggle('step-1', this.step === 1);
      this.root.classList.toggle('step-2', this.step === 2);
      this.grid.querySelectorAll('[data-fbb-card]').forEach(function (card) {
        const t = self.cardType(card);
        card.style.display = (t === cur) ? '' : 'none';
        card.classList.toggle('fbogo-free', t === 'get');
      });
      this.stepInds.forEach(function (ind) {
        const n = parseInt(ind.dataset.fbogoStepInd, 10);
        ind.classList.toggle('is-active', n === self.step);
        ind.classList.toggle('is-done', n < self.step);
      });
      if (this.backEl) this.backEl.hidden = this.step === 1;
    }

    render() {
      this.renderCards();
      this.renderProgress();
    }

    renderCards() {
      if (!this.grid) return;
      const self = this;
      this.grid.querySelectorAll('[data-fbb-card]').forEach(function (card) {
        const t = self.cardType(card);
        const sel = self.selFor(t);
        const limit = self.limitFor(t);
        const productId = card.dataset.productId;
        const qty = self.qtyOf(sel, productId);
        const isSelected = qty > 0;
        const needsPick = card.dataset.needsPick === 'true';

        card.classList.toggle(SELECTED_CLASS, isSelected);
        card.classList.toggle(LOCKED_CLASS, sel.length >= limit && !isSelected);

        const numEl = card.querySelector('[data-fbb-num]');
        if (numEl) numEl.textContent = isSelected ? ('×' + qty) : '';
        const qtyEl = card.querySelector('[data-fbb-qty]');
        if (qtyEl) qtyEl.textContent = qty;
        const plusBtn = card.querySelector('[data-fbb-qty-plus]');
        if (plusBtn) plusBtn.disabled = sel.length >= limit;

        if (needsPick) {
          const hasPicked = !!self.pendingVariants[productId] || isSelected;
          card.classList.toggle(HAS_VARIANT_CLASS, hasPicked);
          const action = card.querySelector('[data-fbb-action]');
          if (action) action.disabled = !hasPicked && !isSelected;
          if (isSelected) {
            const s = sel.find(function (i) { return i.productId === productId; });
            const vId = s ? s.variantId : null;
            card.querySelectorAll('[data-fbb-variant]').forEach(function (p) {
              const active = p.dataset.variantId === vId;
              p.classList.toggle('is-active', active);
              p.setAttribute('aria-checked', active ? 'true' : 'false');
            });
          }
        }
      });
    }

    renderProgress() {
      const buyN = this.buySel.length, getN = this.getSel.length;
      const buyTotal = this.buySel.reduce(function (s, i) { return s + i.price; }, 0);
      const getTotal = this.getSel.reduce(function (s, i) { return s + i.price; }, 0);

      if (this.step === 1) {
        if (this.countEl) this.countEl.innerHTML = '<strong>' + buyN + '</strong> / ' + this.buyQty + ' necklaces';
        if (this.barFillEl) this.barFillEl.style.width = (buyN / this.buyQty * 100) + '%';
        if (this.amountEl) this.amountEl.textContent = this.formatMoney(buyTotal);
        if (this.savedEl) this.savedEl.textContent = buyN >= this.buyQty ? ('Then ' + this.getQty + ' bracelets free') : ((this.buyQty - buyN) + ' to go');
        if (this.ctaEl) {
          const ready = buyN === this.buyQty;
          this.ctaEl.classList.toggle('is-ready', ready);
          this.ctaEl.disabled = !ready;
          this.ctaEl.textContent = ready ? 'Next: your free bracelets →' : ('Pick ' + (this.buyQty - buyN) + ' necklace' + (this.buyQty - buyN > 1 ? 's' : ''));
        }
      } else {
        if (this.countEl) this.countEl.innerHTML = '<strong>' + getN + '</strong> / ' + this.getQty + ' free bracelets';
        if (this.barFillEl) this.barFillEl.style.width = (getN / this.getQty * 100) + '%';
        if (this.amountEl) this.amountEl.textContent = this.formatMoney(buyTotal);
        if (this.savedEl) this.savedEl.textContent = getN > 0 ? ('You save ' + this.formatMoney(getTotal)) : (this.getQty + ' free to pick');
        if (this.ctaEl) {
          const ready = getN === this.getQty;
          this.ctaEl.classList.toggle('is-ready', ready);
          this.ctaEl.disabled = !ready;
          this.ctaEl.textContent = ready ? 'Add to cart' : ('Pick ' + (this.getQty - getN) + ' free bracelet' + (this.getQty - getN > 1 ? 's' : ''));
        }
      }
    }

    applyDiscountCode() {
      if (!this.code) return Promise.resolve();
      return fetch('/discount/' + encodeURIComponent(this.code), { method: 'GET', redirect: 'manual' })
        .then(function () {}).catch(function () {});
    }

    addAllToCart() {
      if (this.buySel.length !== this.buyQty || this.getSel.length !== this.getQty) return;
      if (this.ctaEl) this.ctaEl.classList.add('is-loading');
      const all = this.buySel.concat(this.getSel);
      const qtyByVariant = {};
      all.forEach(function (i) { const v = parseInt(i.variantId, 10); qtyByVariant[v] = (qtyByVariant[v] || 0) + 1; });
      const items = Object.keys(qtyByVariant).map(function (v) {
        return { id: parseInt(v, 10), quantity: qtyByVariant[v], properties: { '_fair_bundle': '2necklaces-2bracelets' } };
      });
      const self = this;
      this.applyDiscountCode()
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (resp) {
          if (!resp.ok) return resp.json().then(function (err) { throw new Error(err.description || err.message || 'Add to cart failed'); });
          return resp.json();
        })
        .then(function () {
          self.buySel = []; self.getSel = []; self.pendingVariants = {}; self.step = 1;
          self.applyStepFilter(); self.render();
          return self.refreshCartDrawerSection();
        })
        .then(function () { self.openCartDrawer(); if (self.ctaEl) self.ctaEl.classList.remove('is-loading'); })
        .catch(function (e) { self.showToast(e.message || 'Something went wrong. Try again.', 'warning'); if (self.ctaEl) self.ctaEl.classList.remove('is-loading'); });
    }

    refreshCartDrawerSection() {
      return fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          try {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const nd = tmp.querySelector('cart-drawer') || tmp.querySelector('#cart-drawer');
            const od = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
            if (nd && od) { od.innerHTML = nd.innerHTML; od.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
          } catch (e) {}
        }).catch(function () {});
    }

    openCartDrawer() {
      ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (ev) {
        document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      const drawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
      if (drawer && typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
      if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
      const toggle = document.querySelector('[aria-controls="cart-drawer"]') || document.querySelector('[data-cart-toggle]');
      if (toggle) { try { toggle.click(); return; } catch (e) {} }
      this.showToast('Added — open your cart to check out.', 'warning');
    }

    showToast(msg, variant) {
      if (!this.toast) return;
      this.toast.textContent = msg;
      this.toast.className = 'fbb-toast is-visible';
      if (variant) this.toast.classList.add('is-' + variant);
      clearTimeout(this._t);
      const self = this;
      this._t = setTimeout(function () { self.toast.classList.remove('is-visible'); }, 2500);
    }

    formatMoney(cents) {
      const v = cents / 100;
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(v); }
      catch (e) { return '$' + v.toFixed(0); }
    }
  }

  function boot() {
    const root = document.querySelector('[data-fbogo-root]');
    if (!root) return;
    new BogoBuilder(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
